<x-shop-dialog
  heading="Are you sure you want to leave?"
  subheading="Any changes made to your address will not be saved."
  (closeDialog)="matDialogRef.close()"
>
  <x-shop-dialog-actions>
    <button mat-stroked-button color="primary" xAction (click)="closeDialog()">
      Yes, I am sure
    </button>
    <button mat-flat-button color="primary" xAction (click)="matDialogRef.close()">No</button>
  </x-shop-dialog-actions>
</x-shop-dialog>
